<share-buttons theme="modern-dark" [include]="[ 'email', 'linkedin',   'twitter','facebook',  'whatsapp','copy']"
  [showIcon]="true" [showText]="true" [url]="url" [description]="description" class="pt-5">
</share-buttons>
